import React from "react";
import { Grid, IconButton, Avatar } from '@material-ui/core'
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Hidden
} from "@material-ui/core";
import { RemoveCircle, Create, Close, Check } from "@material-ui/icons";
import DelegateStore from "../../stores/DelegateStore";
import SearchUserToAction from '../SearchUserToAction';
import withSnack from "../withSnack";
import { ModalConfirmation } from '../DocDialogs';
import extract_user from '../../functions/extract'

export class SearchUserDelegate extends React.Component {
  constructor(props) {
    super(props);
    if (this.getStore === undefined) {
      throw new TypeError("Must override getStore");
    }
    this.state = {
      users: [],
      ismodalOpen: false,
      action: '',
      user: ''
    };
  }

  componentDidMount() {
    const { type } = this.props;
    const users = this.getStore().listUsers(type);
     if(users !== undefined){
       users.then(r => {
         this.setState({ users: r.data });
       });
     }
  }

  getStore() {
    return DelegateStore;
  }

  openModal = (user, type, action) => {
    this.setState({ ismodalOpen: true, action: action, user: user })
  }

  closeModal = () => {
    this.setState({ ismodalOpen: false, action: '', user: '' })
  }

  userAlreadyDelegated = (arr, user) => {
    return arr.some(function(el){
      return (el.id === user.id  || el.email === user.email)
    })
  }

  addDelegate = (user, type, reply) => {
    const arr = this.state.users;
    const checkUser = this.userAlreadyDelegated(arr, user)
    //check if user already has this permission
    if(checkUser === true){
          this.props.snack('El usuario ya esta delegado', 'warning')
          this.closeModal();
    }
    else{
      this.getStore()
        .addDelegateStore(user.id, type, reply)
        .then(r => {
          this.props.snack('El usuario fue delegado con éxito', 'success')
          this.setState(prevState => {
            return {
              users: [{ ...user, [type+"_id"] : r.data.id, reply: reply },...prevState.users]
            };
          });
        })
        .catch(() => {
          this.props.snack('Ocurrió un error', 'warning')
        })
        this.closeModal();
    }

  };

  removeDelegate = (user, type) => {
    this.getStore()
      .removeDelegateStore(user, type)
      .then(r => {
        this.props.snack('Se revocó la delegación con éxito', 'success')
        this.setState(prevState => {
          return { users: prevState.users.filter(x => x.id !== user.id) };
        });
      })
      .catch(() => {
        this.props.snack('Ocurrió un error', 'warning')
      })
      this.closeModal();
  };

  editDelegate = (user, type, reply) => {
    this.getStore()
      .editDelegateStore(user, type, reply)
      .then(r => {
        this.props.snack('Se modificó al usuario con éxito', 'success')
        this.setState(prevState => {
          return {
            users: [{ ...user, [type+"_id"] : r.data.id, reply: reply },...prevState.users.filter(x => x.id !== user.id) ]
          };
        });
      })
      .catch(() => {
        this.props.snack('Ocurrió un error', 'warning')
      })
      this.closeModal();
  };

  render() {
    const { users, ismodalOpen, action, user } = this.state;
    const { type } = this.props;

    let modal = null;

    if(ismodalOpen){
      modal = (
        <ModalConfirmation
          open={ismodalOpen}
          close={this.closeModal}
          type={type}
          action={action}
          removeDelegate={this.removeDelegate}
          editDelegate={this.editDelegate}
          addDelegate={this.addDelegate}
          user={user} />
      );
    }

    return (
      <Grid container justify="space-between" direction="row" alignItems="flex-start">
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          <SearchUserToAction
            onChange={this.openModal}
            includeGroups={false}
          />
        </Grid>
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12} className="subsection_container_list">
          <List>
            { type === 'reviewer' && users.length > 0 ? <Hidden only={['xs','sm']}><Grid container><Grid item xs={2} sm={2} md={2} lg={9} xl={10}></Grid><Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="option_header">Responder oficio</Grid></Grid></Hidden> : null }
            {users.map(u => (
              <ListItem key={u.id} style={{padding:"10px 0px"}}>
                <Avatar alt="avatar" className="avatar">{u.name.full.slice(0,2)}</Avatar>
                <ListItemText primary={u.temp? u.name.full : u.name.title+' '+u.name.full} secondary={extract_user(u.email)} />
                <ListItemSecondaryAction>
                  { type === 'reviewer'? <React.Fragment>
                    {u.reply ? <Check className="check"/> : <Close className="unavailable"/>}
                    <IconButton onClick={(e) => this.openModal(u, type, 'Edit')} style={{padding: 0, marginRight: 20}}><Create /></IconButton></React.Fragment>
                  : null }
                  <IconButton onClick={(e) => this.openModal(u, type, 'Remove')} style={{padding: 0}}>
                    <RemoveCircle />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Grid>
        {modal}
      </Grid>
    );
  }
}

SearchUserDelegate.propTypes = {};

export default withSnack(SearchUserDelegate);



// WEBPACK FOOTER //
// ./src/components/containers/SearchUserDelegate.js